import React, { useEffect, useState } from "react";
// import Header from "../../components/header/Header.tsx";
// import Navbar from "../../components/navbar/Navbar.tsx";
// import Footer from "../../components/footer/Footer.tsx";
import MainImg from "../../assets/images/complain-main-img.png";
import { useNavigate, useParams } from "react-router-dom";
import { getFetcher, postFetcher } from "../../../api/fetchers.ts";
import { endpoints } from "../../../api/endpoints.ts";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "../../components/spinner/Spinner.tsx";
import ProductCart from "../../components/ProductCart.tsx";
import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext.tsx";
import { useUser } from "../../context/UserContext.tsx";


const Complain: React.FC = () => {
  const {t} = useLanguage();
  const { user} = useUser();
  const { id } = useParams();
  const navigate = useNavigate();
  const [complains, setComplains] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [products, setProducts]: any = React.useState([]);
  const [main, setMain]: any = React.useState({});
  const [userBusinessPackage, setUserBusinessPackage] = useState<any>();

  const getMainComplains = async () => {
    try {
      const data = await getFetcher(
        endpoints.complain.getComplainsById.replace("{id}", id || "")
      );
      setMain(data.main);
      setComplains(data.complains);
      setLoading(false);
    } catch (error) {
      navigate("/");
      toast.error("Error");
    }
  };

  const getProductCategory = async () => {
    try {
      // ID'ye göre subCategory ID'lerini belirle
      const subCategoryMap: { [key: string]: number[] } = {
        "1": [33, 29, 47], // Karın ve Göğüs
        "2": [72, 71, 84, 85, 37, 38, 48], // El ve Kol
        "3": [76, 67, 82], // Bel ve Sırt
        "4": [75, 73, 44], // Ayak ve Diz
        "5": [74, 73, 86, 54, 53, 51, 52, 41, 87, 40], // Ayak ve Diz
        "6": [70, 71, 36, 48, 81], // Kol ve Omuz
        "7": [50, 35, 29], // Kalça ve Kasık
        "8": [72, 86, 84, 38, 37], // Bilek
        "9": [69, 62, 31, 47, 80], // Baş ve Boyun
      };

      // Geçerli ID için subCategory ID'lerini al
      const subCategoryIds = subCategoryMap[id || ""] || [];
      let allProducts: any[] = [];

      // Seçili subCategory'ler için ürünleri getir
      for (const subCatId of subCategoryIds) {
        const response = await postFetcher(
          endpoints.products.productsSubCategoryId,
          {
            arg: {
              subCategoryId: subCatId,
              pageNumber: 0,
            },
          }
        );

        if (response.result && response.products) {
          allProducts = [...allProducts, ...response.products];
        }
      }

      // Tüm ürünleri state'e kaydet
      setProducts(allProducts);

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchSubCategoryProducts = async () => {
      try {
        // SubCategory ID'leri
        const subCategoryIds = [33, 29, 47];
        const allProducts = [];

        // Her bir subCategory için ürünleri getir
        for (const id of subCategoryIds) {
          const response = await postFetcher(
            endpoints.products.productsSubCategoryId,
            {
              arg: {
                subCategoryId: id,
                pageNumber: 0,
              },
            }
          );

          if (response.result && response.products) {
            // Her bir subCategory'nin ürünlerini birleştir
            allProducts.push(...response.products);
          }
        }


      } catch (error) {
        console.error("Error fetching sub-category products:", error);
      }
    };

    fetchSubCategoryProducts();
  }, []);

  const fetchBusinessPackageData = async () => {
    if (user) {
      try {
        const businessPackage = await getFetcher(
          endpoints.user.getBusinessPackageById.replace(
            "{id}",
            user.businessPackageId
          )
        );
        if (businessPackage.result) {
          setUserBusinessPackage(businessPackage.businessPackage);
        }
      } catch (error) {
        console.error("Error fetching business package:", error);
      } finally {
        console.log("first");
      }
    } else {
      console.log("err");
    }
  };

  useEffect(() => {
    fetchBusinessPackageData();
  }, [user]);

  React.useEffect(() => {
    getMainComplains();
    getProductCategory();
  }, []);

  return (
    <div className="flex flex-col min-h-[80rem]">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {/* <Header /> */}
      {/* <div className={` top-0 left-0 w-full z-30`}>
        <Navbar />
      </div> */}

      {loading ? (
        <Spinner />
      ) : (
        <div className="w-11/12 mx-auto">
          <div className="flex justify-between items-center mt-2 md:mt-0">
            <div className="md:w-2/3">
              <p className="font-medium text-[#03363D]">{main?.title}</p>
              <p className="text-5xl mt-2 font-bold text-[#FFC633]">
                {t('complain', 'title')}
              </p>
              <p className="mt-4 md:w-[70%] text-[#17494D] font-normal">
              {t('complain', 'subTitle')}
              </p>
            </div>
            <img
              src={MainImg}
              className="w-[365px] h-[454px] hidden md:flex"
            ></img>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 gap-2 mt-32">
            {complains?.map((item: any, index: number) => {
              return (
                <Link
                  key={index}
                  to={`/complain-detail?id=${item?.mainId}&index=${index}`}
                  state={{
                    complain: item,
                    mainId: id,
                    mainTitle: main?.title,
                  }}
                  className="w-full relative group overflow-hidden"
                >
                  <div className="relative w-full h-auto">
                    <div
                      className="absolute inset-0 bg-gradient-to-b from-transparent via-black/50 to-black/80 z-10"
                    ></div>
                    
                    <img
                      src={item.images[0]}
                      className="w-full h-auto relative transition-transform duration-300 group-hover:scale-105"
                      alt={item.title}
                    />
                    
                    <p className="absolute bottom-4 left-0 right-0 text-center font-medium text-white z-20 px-2 font-poppins text-lg">
                      {item.title}
                    </p>
                  </div>
                </Link>
              );
            })}
          </div>

          <p className="text-3xl font-bold flex justify-center text-[#03363D] mb-8 mt-8">
            {t('complain', 'oneri1')} <a className="ml-2 text-[#FFC633]">{t('complain', 'oneri2')}</a>
          </p>

          {products?.length < 1 ? (
            <p className="flex justify-center text-[#03363D] my-5">
              {t('complain', 'noOneri')}
            </p>
          ) : (
            <div className="grid my-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6 gap-14 mt-2 justify-self-center">
              {products?.map((item: any, index: number) => {
                return <ProductCart product={item} key={index} userBusinessPackage={userBusinessPackage}/>;
              })}
            </div>
          )}
          
        </div>
      )}

      {/* <Footer /> */}
    </div>
  );
};

export default Complain;
